import { SpecialDateState } from './duck';
import { createSelector } from '~/helpers/util/selectors';

export const getRoot = (state: any) => {
  return state.core.specialDates as SpecialDateState;
};

export const getSpecialDateById = createSelector([getRoot], state => {
  return state.specialDateById;
});

export const getIsCleared = createSelector(
  [getRoot],
  state => state.status === 'cleared'
);
